// @flow

// Each of these actions is performed on a single user
const discoveredFeedActionTypes = {
  DISCOVERED_FEED_PUBLIC: 'DISCOVERED_FEED_PUBLIC',
};

export type DISCOVERED_FEED_ACTION_TYPES = $Values<typeof discoveredFeedActionTypes>;

export default discoveredFeedActionTypes;
